<template>
  <QuestionBase :id="db.saveField"

                :errors="[...jsErrors]"
                :question="question"
                :valid="!!data.length">
    <div class="accordion sub-items">

      <!-- Selected People -->
      <transition-group name="fade">
        <ObjectCard v-for="(person, index) in data"
                    :id="'guardianSecondaryData' + index"
                    :key="'guardianSecondaryData' + person.id"
                    :ref="'guardianSecondaryData' + index"
                    :select-mode="true"
                    :selected="true"
                    :show-delete="false"
                    :title="cardTitle(person)"
                    :value="data[index]"
                    type="guardianSecondaryData"
                    :loading="loading"
                    @click="deselectConfirm(person, 'Remove person from your secondary Guardians?')"
                    @delete="deletePerson(person.id)"
                    @save="savePerson( null, 'guardianSecondaryData'+index)">

          <PersonWill v-if="person.type === 'person'"
                      :key="'guardianSecondary-form-data' + person.id"
                      v-model="data[index]"
                      :errors-post="errorsPatch"
                      :no-save="true"
                      :objectId="person.id"
                      @save="savePersonForm($event, person)" />

        </ObjectCard>
      </transition-group>
    </div>

    <!-- New People -->
    <transition name="fade">
      <template v-if="!details.primaryPartner">
        <b-button class="btn-question w-100"
                  @click="show.addPerson=true">
          <i class="i-Add text-25 font-weight-800 mr-2"> </i> Add Secondary Guardian
        </b-button>
      </template>
    </transition>

    <WillPeopleModal v-model="show.addPerson"
                     :dataSelected="data"
                     :options="optionsData"
                     :sub-title="'Select your guardians by selecting existing people or adding new people. You can select multiple individuals for this role.'"
                     :hide-type-options="true"
                     :show-charities="false"
                     :show-groups="false"
                     title="Add Secondary Guardian"
                     @dataSelectedUpdate="data=$event"
                     @save="save" />

  </QuestionBase>
</template>

<script>
import {personHelpers} from "@/mixins/personHelpers";
import {peopleSaveHelpers} from "../../objects/peopleSaveHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";
import {willPeopleObjectHelpers} from "../helpers/willPeopleObjectHelpers";

import QuestionBase from "../../../QuestionBase";
import ObjectCard from "../../objects/ObjectCard";
import PersonWill from "../../../../fieldsets/sub/people/PersonWill";
import WillPeopleModal from "../helpers/WillPeopleModal";

export default {
  name: 'SecondaryGuardians',
  components: {
    WillPeopleModal,
    PersonWill,
    ObjectCard,
    QuestionBase
  },
  mixins: [
    peopleSaveHelpers,
    personHelpers,
    questionLoadHelpers,
    saveHelpers,
    willPeopleObjectHelpers
  ],
  props: {
    value: {
      type: Array,
      required: false
    },
    details: {
      type: Object,
      required: true
    },
    optionsData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      db: {
        saveLocation: 'product_will_data',
        saveField: 'secondaryGuardians',
        formPath: 'data.guardians.details.secondary',
        jsonSaveField: 'secondary',
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessage: 'You must have more than one Secondary Pet, click to select'
      },
      serverErrors: [],
      errorsPost: {},
      errorsPatch: {},
      jsErrors: [],
      skipped: false,
      show: {
        addPerson: false
      }
    }
  },
  computed: {
    question() {
      return {
        title: this.data && this.data.length === 1 ? 'Secondary Guardian' : 'Secondary Guardians',
        subTitle: this.details.primaryPartner ? null : 'Please confirm who you would like to act as the secondary guardians. To deselect a person, simply click on their name.',
        tip: null
      }
    },
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  }
}
</script>
